<template>
	<div>
		<!-- Placeholder para mantener el espacio cuando is-stuck está activo -->
		<div v-if="isScrolling" class="form-header-placeholder"></div>
		<div class="form-header" :class="{'is-stuck': isScrolling}">
			<div class="form-header-inner">
				<div class="left">
					<div class="buttons">
						<vs-button v-if="canGoBack" @click.prevent="onBack">{{ backText }}</vs-button>
						<vs-button color="danger" @click.prevent="onCancel">{{ cancelText }}</vs-button>
					</div>
				</div>
				<div class="buttons">
					<vs-button :disabled="disabledSave" @click.prevent="onSave">{{ saveText }}</vs-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import windowScrollPosition from "@/plugins/window-scroll-position.js";

export default {
	mixins: [windowScrollPosition("position")],
	props: {
		disabledSave: {
			type: Boolean,
			default: false,
		},
		canGoBack: {
			type: Boolean,
			default: false,
		},
		saveText: {
			type: String,
			default: "Guardar",
		},
		cancelText: {
			type: String,
			default: "Cancelar",
		},
		backText: {
			type: String,
			default: "Atras",
		},
	},
	computed: {
		isScrolling() {
			return this.position[1] > 30;
		},
	},
	methods: {
		onBack() {
			this.$emit("back");
		},
		onCancel() {
			this.$emit("cancel");
		},
		onSave() {
			this.$emit("save");
		},
	},
};
</script>

<style lang="scss" scoped>
/* Placeholder para evitar el salto cuando el header se vuelve sticky */
.form-header-placeholder {
	height: 60px; /* Altura del header normal */
	width: 100%;
}

.form-header {
	padding: 5px 15px;
	min-height: 60px;
	transition: transform 0.2s ease, box-shadow 0.2s ease;
	z-index: 1000;
	background-color: white;

	&.is-stuck {
		position: fixed;
		top: 60px;
		left: 80px;
		width: calc(100% - 80px);
		border-left: 1px solid #ccc;
		border-bottom: 4px solid rgba(var(--vs-primary), 1);
		box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
		z-index: 41000;
	}

	.form-header-inner {
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 50px;
	}

	.left h3 {
		font-family: var(--font-alt);
		font-size: 1.3rem;
		font-weight: 700;
		color: #333333;
	}

	.buttons {
		display: flex;
		gap: 15px;
		.vs-button {
			font-size: 1rem;
			font-weight: 600;
			transition: background-color 0.3s ease;
			&.mr-3 {
				margin-right: 15px;
			}
		}
	}
}
/* Media Queries */
@media (max-width: 1200px) {
	.form-header-placeholder {
		height: 60px;
	}

	.form-header {
		padding: 14px 20px;
		min-height: 60px;
		&.is-stuck {
			left: 0;
			width: 100%;
		}
		.left h3 {
			font-size: 1.3rem;
		}

		.buttons .vs-button {
			font-size: 0.95rem;
		}
	}
}

@media (max-width: 992px) {
	.form-header-placeholder {
		height: 60px;
	}

	.form-header {
		padding: 12px 18px;
		min-height: 60px;

		.left h3 {
			font-size: 1.2rem;
		}

		.buttons .vs-button {
			font-size: 0.9rem;
		}
	}
}

@media (max-width: 768px) {
	.form-header-placeholder {
		height: 60px;
	}

	.form-header {
		padding: 10px 16px;
		min-height: 60px;

		.left h3 {
			font-size: 1.1rem;
		}

		.buttons {
			gap: 10px;
			.vs-button {
				font-size: 0.85rem;
			}
		}
	}
}

@media (max-width: 576px) {
	.form-header-placeholder {
		height: 40px;
	}

	.form-header {
		padding: 8px 14px;
		min-height: 40px;

		.left h3 {
			font-size: 1rem;
		}

		.buttons {
			flex-direction: column;
			gap: 8px;

			.vs-button {
				width: 100%;
				font-size: 0.9rem;
				text-align: center;
			}
		}
	}
}
</style>
